const composeUrlWithParams = ({
  url,
  params,
}: {
  url: string
  params?: Record<string, string>
}): { urlWithQueryParams: string } => {
  const urlComposed = [
    url,
    params !== undefined ? '?' : undefined,
    params !== undefined
      ? new URLSearchParams(params).toString()
      : undefined,
  ]
    .filter((e) => e !== undefined)
    .join('')

  return { urlWithQueryParams: urlComposed }
}

export { composeUrlWithParams }
